export default __webpack_public_path__ + "static/media/OpenSans-SemiBold.d31d0aaa.ttf";